import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { WorkingTimeModel } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, workingTimeModelSchema } from '../lib/schemas';

export const workingTimeModelService = {
  async getWorkingTimeModels(): Promise<WorkingTimeModel[]> {
    const result = await apiClient.get(apiUrl.workingTimeModels(), {
      validate: envelopeSchema('working_time_models', z.array(workingTimeModelSchema)),
      deduplicate: true,
      context: 'getWorkingTimeModels',
    });
    return result.working_time_models;
  },

  async createWorkingTimeModel(data: Partial<WorkingTimeModel>): Promise<WorkingTimeModel> {
    const result = await apiClient.post(apiUrl.workingTimeModels(), data, {
      validate: envelopeSchema('working_time_model', workingTimeModelSchema),
      context: 'createWorkingTimeModel',
    });
    return result.working_time_model;
  },

  async updateWorkingTimeModel(
    id: string,
    data: Partial<WorkingTimeModel>
  ): Promise<WorkingTimeModel> {
    const result = await apiClient.put(`${apiUrl.workingTimeModels()}/${id}`, data, {
      validate: envelopeSchema('working_time_model', workingTimeModelSchema),
      context: 'updateWorkingTimeModel',
    });
    return result.working_time_model;
  },

  async deleteWorkingTimeModel(id: string): Promise<void> {
    await apiClient.delete(`${apiUrl.workingTimeModels()}/${id}`, {
      context: 'deleteWorkingTimeModel',
    });
  },
};
